import { render, staticRenderFns } from "./CollectionEditModals.vue?vue&type=template&id=6d973d0e&"
import script from "./CollectionEditModals.vue?vue&type=script&lang=js&"
export * from "./CollectionEditModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports